<template>
  <div
    v-if="environment !== 'production'"
    class="
      fixed left-1/2 top-0 z-50 -translate-x-1/2 whitespace-nowrap rounded-b bg-black px-6 py-1 font-bold
      text-white
    "
  >
    {{ environment.toUpperCase() }} ENVIRONMENT
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()
const environment = computed(() => {
  const url = config.public.APP_URL || ''
  if (url.includes('web.novu.io')) {
    return 'local'
  }
  if (url.includes('staging')) {
    return 'staging'
  }
  return 'production'
})
</script>
